import { store } from '@/store';

/**
 * Reject accessibility statement access if it's not enabled
 * @param {*} to destination
 * @param {*} from source
 * @param {*} next next route
 */
export default async function accessibilityAccess(to, from, next) {
  if (!store.getters.getConfiguration.accessibilityDisclaimer) {
    next({ name: 'NotFound' });
  } else {
    next();
  }
}
